import { createAsyncAtom } from '../../lib/state';
import axios from 'axios';
import {
  API_HEADERS,
  BridgeRawSwap,
  BridgeTransaction,
  BRIDGE_SWAP_ENDPOINT,
  toBridgeError,
  toBridgeTransaction,
} from './common';
import { walletAddressAtom } from '../wallet';
import { addAddressPadding } from 'starknet';
import evmWalletAddressAtom from '../wallet/evmWalletAddress';

interface BirdgeHistory {
  transferTransaction: BridgeTransaction;
  bridgeTransaction: BridgeTransaction;
}

const bridgeHistoryAtom = createAsyncAtom<BirdgeHistory[]>(
  async get => {
    try {
      const starknetAddress = await get(walletAddressAtom);
      const evmAddress = await get(evmWalletAddressAtom);

      if (!starknetAddress && !evmAddress) {
        return [];
      }

      const address = starknetAddress ? addAddressPadding(starknetAddress) : evmAddress;

      const historyResponse = await axios.get(BRIDGE_SWAP_ENDPOINT, {
        params: {
          address,
        },
        headers: API_HEADERS,
      });

      if (historyResponse.data.error) {
        throw toBridgeError(historyResponse.data.error);
      }

      const rawSwap = historyResponse.data.data as { swap: BridgeRawSwap }[];
      const histories = rawSwap
        .map(({ swap }) => {
          const [txn1, txn2] = swap.transactions.map(toBridgeTransaction);

          if (txn1.from === address || txn2.to === address) {
            return {
              transferTransaction: txn1,
              bridgeTransaction: txn2,
            };
          } else if (txn2.from === address || txn1.to === address) {
            return {
              transferTransaction: txn2,
              bridgeTransaction: txn1,
            };
          } else {
            return null;
          }
        })
        .filter(history => Boolean(history)) as BirdgeHistory[];

      return histories;
    } catch (e) {
      console.error(e);
      return [];
    }
  },
  undefined,
  ['user-refresh'],
);

export default bridgeHistoryAtom;
